import { Grid, Paper, Typography } from "@mui/material";
import { useFormikContext } from "formik";
import FormikTextField from "../../../../commons/formik/FormikTextField";
import { handleGetTotalTrabajadores } from "../utilsCabecera";


const TrabajadoresPaper = () => {

  const { values, errors } = useFormikContext();

  return (
    <Paper>
      <Grid container style={{ padding: 20 }} spacing={2}>
        <Grid item xs={6}>
          <FormikTextField
            fullWidth
            id="cantidadTrabajadoresProduccion"
            name="cantidadTrabajadoresProduccion"
            type="number"
            label="Cantidad de Trabajadores en Producción *"
          />
        </Grid>
        <Grid item xs={6}>
          <FormikTextField
            fullWidth
            id="cantidadTrabajadoresEventualesProduccion"
            name="cantidadTrabajadoresEventualesProduccion"
            type="number"
            label="Cantidad de Trabajadores Eventuales en Producción *"
          />
        </Grid>
        <Grid item xs={6}>
          <FormikTextField
            fullWidth
            id="cantidadTrabajadoresAdministracion"
            name="cantidadTrabajadoresAdministracion"
            type="number"
            label="Cantidad de Trabajadores en Administración *"
          />
        </Grid>
        <Grid item xs={6}>
          <FormikTextField
            fullWidth
            id="cantidadTrabajadoresEventualesAdministracion"
            name="cantidadTrabajadoresEventualesAdministracion"
            type="number"
            label="Cantidad de Trabajadores Eventuales en Administración *"
          />
        </Grid>
        <Grid item xs={12}>
          <Typography>
            <strong>Total Trabajadores:</strong>{" "}
            {handleGetTotalTrabajadores(values, errors)}
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default TrabajadoresPaper;